import OrderSummary from "../Shared/OrderSummary";
import AcknowledgeRecurringDonationMessage from "../Shared/AcknowledgeRecurringDonationMessage";
import SmsLegalLinks from "../Shared/SmsLegalLinks";
import OrderTotal from "../Shared/OrderTotal";
import SubmitButton from "../Shared/SubmitButton";
import { Say } from "../../languages";

const ChosenOrderSummary = ({ products, formEnabled, handleSubmit }) => (
  <OrderSummary visible={true}>
    <AcknowledgeRecurringDonationMessage />
    <SmsLegalLinks />
    <OrderTotal
      className="order-summary__total"
      products={products}
      disabled={!formEnabled}
      totalDefault={39}
    />
    <SubmitButton className="order-summary__submit" onSubmit={handleSubmit} disabled={!formEnabled}>
      <Say phrase="chosen.submission.cta" />
    </SubmitButton>
  </OrderSummary>
);

export default ChosenOrderSummary;
